/** @module csi/skintheme/SunsetBoulevard */
define([], function() {
	return {
		Blue1: "Blue30",
		Blue2: "Blue50",
		Blue3: "Red400",

		PrimaryBlue: "Red600",
		PrimaryDisabledColor: "Red100",
		PrimaryColor2: "Red700",
		PrimaryColor3: "Red800",

		SiteHeaderBackground: "Black200",

		CompanyHeaderBlue1: "Black200",
		CompanyHeaderBlue2: "Black400",

		/* LINK */
		LinkNormal: "Blue600",
		LinkHover: "Blue800",
		LinkActive: "Blue600",

		/* Comment */
		CommentActiveColor: "Blue600",

		/** custom view */
		CustomViewOptionActiveColor: "Blue500",

		/* FULL SCREEN HEADER */
		FullScreenHeaderBackgroundColor: "Black200",
		FullScreenLogoBackgroundColor: "Black200",

		/* TEXT */
		TabsTextActive: "PrimaryText",

		/* Button */
		BtnPrimaryFocusedBorderColor: "Red900",
		ButtonSwitchNormalIconStateOnBackgroundColor: "Red600",

		/* BreadCrumb */
		BreadcrumbNormalLinkColor: "Blue600",

		/* CheckBox */
		CheckBoxFocusColor: "Blue300",

		/* Text Border */
		TextfieldActiveBorderColor: "Black200",
		BtnToolbarFocusedBorderColor: "Black200",

		/* DropDown */
		DropdownSelectActiveBorderColor: "Black200",

		/* Header */
		LastVisitedBackgroundColor: "PrimaryWhite",
		LastVisitedIconColor: "SiteHeaderBackground",
		PageHeaderButtonTextColor: "PrimaryWhite",
		PageHeaderToolbarIconColor: "PrimaryWhite",
		PageHeaderToolbarHoverColor: "PrimaryWhite",
		PageHeaderSearchInButtonHoverColor: "BtnSecondaryHoverBackgroundColor",
		PageHeaderToolbarSeparatorColor: "WhiteOpacity20",
		PageHeaderSearchScopeBackgroundColor: "BtnSecondaryNormalBackgroundColor",
		PageHeaderSearchBlockBackgroundColor: "TextfieldNormalBackgroundColor",
		CompanyLogoTextColor: "WhiteTextColor",
		CompanyLogoImageURL: "DarkCompanyLogoIconURL",
		ExitFullScreenIconURL: "DarkExitFullScreenIconURL",

		/* Table */
		TableCopyBorderColor: "Blue600",
		TablePasteBorderColor: "Blue600",
		TableNewRowBackgroundColor: "Blue100",

		/* Slicer */
		SlicerMetricsBackgroundColor: "Red100",

		/* Chart */
		ChartAreaURL: "ChartAreaRedURL",
		ChartBarURL: "ChartBarRedURL",
		ChartColumnURL: "ChartColumnRedURL",
		ChartDoughnutURL: "ChartDoughnutRedURL",
		ChartLineURL: "ChartLineRedURL",
		ChartMsAreaURL: "ChartMsAreaRedURL",
		ChartMsBarURL: "ChartMsBarRedURL",
		ChartMsColumnURL: "ChartMsColumnRedURL",
		ChartMsLineURL: "ChartMsLineRedURL",
		ChartParetoURL: "ChartParetoRedURL",
		ChartPieURL: "ChartPieRedURL",
		ChartStackedAreaURL: "ChartStackedAreaRedURL",
		ChartStackedBarURL: "ChartStackedBarRedURL",
		ChartStackedColumnURL: "ChartStackedColumnRedURL",

		/* Progress bar */
		ProgressBarDeterminateProgressColor: "PrimaryColor",

		HighlightSelected: "Grey200"
	};
});